export default "__VITE_ASSET__36720053__"